import { darken } from 'polished';
import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    justify-content: space-between;
    h3 {
        margin: 6px 0;
    }
    ${p => p.theme.xs(css`
        flex-direction: column;
    `)}
    ${p => p.theme.sm.min(css`
        margin-top: -12px;
    `)}
    ${p => p.theme.md.min(css`
        margin-bottom: -28px;

        &.NoSubscribe {
            margin-bottom: -46px;
        }
    `)}
`;

export const TextIcon = styled.div`
    line-height: 49px;
    font-weight: 300;
`;

export const Wait = styled.div`
    position: absolute;
    color: ${p => darken(0.05, p.theme.c.info)};
    bottom: -2px;
    right: -2px;
    [class^="i-"] {
        font-size: 24px;
    }
`;